'use client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { SessionSyncProvider } from '@/lib/session-sync';
import { NavigationPendingProvider } from '@/lib/navigation-pending';

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <SessionSyncProvider>
        <NavigationPendingProvider>{children}</NavigationPendingProvider>
      </SessionSyncProvider>
    </QueryClientProvider>
  );
}
